<!-- 
  NOTES:
    - the id of the <input> element uses props.name by default but can be
      overridden on the parent element if needed. This ensures all input elements
      have an id which decreases browser warnings in the console
    
    - fluid attribute expands input width by default
    
    - autocomplete is set to 'off' by default to supress browser autofill on most forms
    
    - data-1p-ignore attribute is added to hide 1Password manager extension/helper from 
      inputs by default: https://developer.1password.com/docs/web/compatible-website-design/
-->
<template lang="pug">
label.label(v-if="label" :for="name") {{ label }}
FormField(v-slot="$field" :name="name")
  InputText(
    v-model="$field.value"
    :class="$attrs.class"
    :type="$attrs.type || 'text'"
    :id="$attrs.id || name"
    :autocomplete="$attrs.autocomplete || 'off'"
    :placeholder="$attrs.placeholder"
    data-1p-ignore
    fluid
  )
  Message(v-if="$field?.invalid && ($field?.touched || formSubmitted)" severity="error" size="small" variant="simple") {{ $field.error?.message }}
  //- pre $field: {{$field}}
</template>

<script setup>
import { inject, ref } from 'vue'
import InputText from "primevue/inputtext"
import { FormField } from '@primevue/forms';
import Message from 'primevue/message';

const formSubmitted = inject('appFormSubmitted', ref(false))

const props = defineProps({
  name:   { type: String, required: true },
  label:  { type: String, required: false },
})

defineOptions({inheritAttrs: false})
</script>